import { render, staticRenderFns } from "./UltimateBeneficialOwnerDialog.vue?vue&type=template&id=e3b793c8&"
import script from "./UltimateBeneficialOwnerDialog.vue?vue&type=script&lang=js&"
export * from "./UltimateBeneficialOwnerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VDivider,VSubheader})
